"use client";
import * as React from "react";

interface Option {
  label: string;
  value: string;
}

interface FormInputProps {
  label: string;
  className?: string;
  variant?: "light" | "dark";
  value?: string;
  onChange?: (
    // eslint-disable-next-line no-unused-vars
    _e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => void;
  // eslint-disable-next-line no-unused-vars
  onFocus?: (_e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: "text" | "select";
  options?: Option[];
}

export const SelectInput: React.FC<FormInputProps> = ({
  label,
  className = "",
  variant = "light",
  value = "",
  onChange,
  type = "text",
  options = [],
}) => {
  const [isFocused, setIsFocused] = React.useState(false);

  const baseClasses = `
    w-full
    border-b
    bg-transparent
    outline-none
    transition-all
    ${
      variant === "dark"
        ? "border-white/20 text-white"
        : "border-b-[color:var(--Stroke-2,#E3E3E3)] text-zinc-800"
    }
    ${isFocused || value ? "pt-6 pb-2" : "py-4"}
  `;

  return (
    <div
      className={`flex-1 basis-[100%] 2xl:basis-0 w-full 2xl:w-auto ${className}`}
    >
      <label
        htmlFor={`select-${label.replace(/\s+/g, "-").toLowerCase()}`}
        className={`relative block text-base ${
          variant === "dark" ? "text-white" : "text-zinc-600"
        }`}
      >
        {type === "select" ? (
          <select
            id={`select-${label.replace(/\s+/g, "-").toLowerCase()}`}
            value={value}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            onChange={onChange}
            className={baseClasses}
            aria-label={label}
          >
            <option value="" disabled hidden />
            {options?.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        ) : (
          <input
            id={`input-${label.replace(/\s+/g, "-").toLowerCase()}`}
            type="text"
            value={value}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            onChange={onChange}
            className={baseClasses}
            aria-label={label}
          />
        )}

        <span
          className={`
            absolute
            left-0
            pointer-events-none
            transition-all
            ${isFocused || value ? "text-sm top-1" : "top-4"}
          `}
        >
          {label}
        </span>
      </label>
    </div>
  );
};
